import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
    const baseUrl = 'https://jermingo.com';
    
    useEffect(() => {
        // Update document title
        document.title = 'Privacy Policy | Jermingo';
        
        // Update meta description
        let metaDesc = document.querySelector('meta[name="description"]');
        if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.setAttribute('name', 'description');
            document.head.appendChild(metaDesc);
        }
        metaDesc.setAttribute('content', 
            'Read Jermingo\'s Privacy Policy. Learn how we handle your data, cookies, and third-party services like Google AdSense on our travel blog.'
        );
        
        // Add canonical URL
        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            document.head.appendChild(canonical);
        }
        canonical.setAttribute('href', `${baseUrl}/privacy`);
    }, []);
    
    return (
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
            <h1>Privacy Policy</h1>
            <p>
                At Jermingo, we value your privacy. This Privacy Policy outlines the types of personal information 
                that may be collected by third-party services we use, such as Google AdSense, and how that information is used.
            </p>

            <h2>Information We Do Not Collect</h2>
            <p>
                Jermingo does not collect, store, or process any personal data from users. We do not require you to 
                create an account, submit forms, or provide any personal information to use our website.
            </p>

            <h2>Third-Party Services</h2>
            <p>
                While we do not collect any personal data, we use third-party services such as Google AdSense to 
                display advertisements on our website. These services may collect and use data to provide personalized 
                ads based on your browsing history.
            </p>
            <p>
                Google AdSense, as a third-party vendor, uses cookies to serve ads on this site. Google's use of the 
                DoubleClick cookie enables it and its partners to serve ads to users based on their visit to this site 
                and/or other sites on the Internet. Users may opt out of the use of the DoubleClick cookie for 
                interest-based advertising by visiting the <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">Google Ads Settings</a>.
            </p>

            <h2>Cookies</h2>
            <p>
                Cookies are small text files that are stored on your device to improve your browsing experience. 
                Google AdSense may use cookies to serve personalized ads. You can disable cookies in your browser 
                settings if you prefer not to allow them.
            </p>

            <h2>External Links</h2>
            <p>
                Our website may contain links to external websites. We are not responsible for the privacy practices 
                or content of these external sites. Please review their privacy policies for more information.
            </p>

            <h2>Changes to This Privacy Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. Any changes will be reflected on this page. 
                We encourage you to review this Privacy Policy periodically to stay informed about how we are 
                protecting your information.
            </p>

            <h2>Contact Us</h2>
            <p>
                If you have any questions about this Privacy Policy, you can contact us at:
            </p>
            <ul>
                <li>Email: <a href="mailto:privacy@jermingo.com">privacy@jermingo.com</a></li>
            </ul>
        </div>
    );
};

export default PrivacyPolicy;